import { handleWarning } from "@/vuex/modules/warning";
import { initialState } from "@/vuex/store";

const STATE_KEY = "importedDataWarning";
const RESULT_TYPE = "imported-data-warning";
const RESULT = {
  continue: { type: RESULT_TYPE, result: "continue" },
  cancel: { type: RESULT_TYPE, result: "cancel" }
};

export default {
  async withImportedDataWarning({ dispatch }, { action, record, context }) {
    return handleWarning({
      condition: record?.imported,
      warningDispatch: () =>
        dispatch("showImportedDataWarning", { record, context }),
      action
    });
  },
  showImportedDataWarning({ commit }, { record, context }) {
    return new Promise((resolve, reject) => {
      commit("replace", {
        state: STATE_KEY,
        data: {
          show: true,
          record,
          context,
          resolve,
          reject
        }
      });
    });
  },
  hideImportedDataWarning({ commit }) {
    commit("replace", {
      state: STATE_KEY,
      data: initialState()[STATE_KEY]
    });
  },
  confirmImportedDataWarning({ dispatch, state }) {
    state[STATE_KEY].resolve(RESULT.continue);
    dispatch("hideImportedDataWarning");
  },
  cancelImportedDataWarning({ dispatch, state }) {
    state[STATE_KEY].reject(RESULT.cancel);
    dispatch("hideImportedDataWarning");
  }
};
